<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >
      <!--<div class="row1" v-for="(row,i) in catelist"  v-if="i<3">-->
        <!--<img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--</div>-->
      <div class="row3">
        <img  v-rblink="{name:'NewsList',query:{cate_id:row.id}}" v-for="(row,i) in catelist"  v-if="i>=1" :src="row.pic_url" />
        <div style="clear: both"></div>
      </div>

      <div class="logo-ul">
        <div v-for="(row,i) in list" >
          <img  v-rblink="{name:'NewsDetail',query:{id:row.id}}"  :src="row.pic_url" />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row1 img{
    width: 100%;
    margin: 10px 0 0 0 ;
  }
  .row3{
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: space-between;*/
    margin: 10px 10px;
    /*flex-wrap: wrap;*/
  }
  .row3 img{
    float: left;
    width: calc(33.33% - 10px);
    margin: 0 10px 10px 0;
  }
  .logo-ul{
    background: #fff;
    border-radius: 10px;
    height: 100px;
    margin: 0 10px;
  }
  .logo-ul div{
    text-align: center;
    float: left;
    width: calc(33.33% - 10px);
    margin: 0 0 10px 10px;
    line-height: 110px;
    height: 110px;
  }
  .logo-ul img{
    width: 100%;
    display: inline-block;
  }

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "NewsList",
  components: {
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
      ],
      catelist:[],
      list:[],
      params:{
        parent_id:39
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "商务合作";
    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/catelist",{
                parent_id:39
              },
              res => {
                that.catelist = res.data
              },
              res => {
                Toast(res.msg);
              }
      );
      that.$api.get(
              "/api/cms/cmsList",{
                cate_id:53,
                pageNo:1,
                pageSize:100
              },
              res => {
                that.list = res.data.list
              },
              res => {
                Toast(res.msg);
              }
      );
    },
  }
};
</script>



// WEBPACK FOOTER //
// Saishizhaoshang.vue?90c00420